import React from 'react';
import { useStyles } from '@wix/tpa-settings/react';
import stylesParams from '../../stylesParams';
import { Title } from './Title/Title';
import { st, classes } from './Header.st.css';

export const Header = () => {
  const styles = useStyles();
  const displayTitle = styles.get(stylesParams._titleDisplay);

  if (!displayTitle) {
    return null;
  }

  return (
    <div className={st(classes.root)}>
      <Title />
    </div>
  );
};
